import { useUserStore } from '~/store/useUserStore'

export default defineNuxtRouteMiddleware((to) => {
    const { isAuthenticated } = useUserStore()
    if (!['/auth', '/reset', '/userresetpassword'].includes(to.path) && !isAuthenticated) {
        console.log('global auth middleware')
        return navigateTo('/auth')
    }
})
